
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study-destinations/[slug]",
      function () {
        return require("private-next-pages/study-destinations/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/study-destinations/[slug]"])
      });
    }
  